module.exports = __webpack_public_path__ + "img/PayPal_200x104_V2.77ff8ca.svg";